/** @format */

export interface ProductStylePrices {
  mapPriceIndicator: 1 | 0;
  maxlistprice: string;
  maxofferprice: string;
  minlistprice: string;
  minofferprice: string;
  priceIndicator: 1 | 0;
}
